import { Component, OnDestroy, inject } from '@angular/core';
import { SceneService } from '../../services/scene.service';
import { ReplaySubject, takeUntil } from 'rxjs';
import User from 'entity/User';
import { ConvertGroupMessage, OutgoingMessageType } from 'messages/websocket.messages';
import { WebsocketService } from '../../services/websocket.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Store } from '@ngrx/store';
import { actions } from '../../state/app';

@Component({
  selector: 'app-sag-debugger',
  templateUrl: './sag-debugger.component.html',
  styleUrl: './sag-debugger.component.scss',
  standalone: false,
})
export class SagDebuggerComponent implements OnDestroy {
  private store = inject(Store);
  private sceneService = inject(SceneService);
  private websocketService = inject(WebsocketService);

  private destroyed$ = new ReplaySubject<boolean>(1);
  protected sagStates: { clusterId: number; queue: User[] }[] = [];
  private sagQueue = new Map<number, User[]>();

  public constructor() {
    this.sceneService.sceneManager?.sagQueue$.pipe(takeUntil(this.destroyed$)).subscribe((sagQueue) => {
      this.handleSagMapChange(sagQueue);
    });
  }

  private handleSagMapChange(sagQueue: Map<number, User[]>) {
    const sagStateMap: { clusterId: number; queue: User[] }[] = [];
    sagQueue.forEach((item, key) => {
      sagStateMap.push({
        clusterId: key,
        queue: item,
      });
    });
    this.sagStates = sagStateMap;
  }

  protected clearSagState() {
    this.sagQueue.clear();
    this.sceneService.sceneManager?.sagQueue$.next(this.sagQueue);
  }

  protected enableSpecialAccessGroup() {
    const msg: ConvertGroupMessage = {
      t: OutgoingMessageType.CONVERT_GROUP,
      sag: true,
    };
    this.websocketService.sendMessage(msg);
  }

  protected disableSpecialAccessGroup() {
    const msg: ConvertGroupMessage = {
      t: OutgoingMessageType.CONVERT_GROUP,
      sag: false,
    };

    this.websocketService.sendMessage(msg);
  }

  protected removeQueueFromState(clusterId: number) {
    this.sagQueue.delete(clusterId);
    this.sceneService.sceneManager?.sagQueue$.next(this.sagQueue);
  }

  protected onChangeSagPlayerStats(event: MatSlideToggleChange) {
    this.store.dispatch(actions.UPDATE_SHOW_SAG_DEBUGGER_STATS({ showSagDebuggerStats: event.checked }));
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
